import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './redux';
import { Header } from './component';


export default connect(mapStateToProps, mapDispatchToProps)(Header);
